/* useNoIndex — adds `<meta name="robots" content="noindex,nofollow">`
   while the calling page is mounted, then removes it on unmount.

   Why a hook (vs. putting it in `index.html`):
   - Default behaviour for the marketing/landing pages stays "indexable".
   - Only the per-tenant public surfaces (quotes, timelines, trials,
     lead forms) opt-out — exactly the pages that may contain personal
     data (bride name, wedding date, location, contact email).

   Also sets the canonical robots meta if Google has already seen the
   page once (useful when redeploying without flushing the CDN).
*/
import { useEffect } from "react";

export default function useNoIndex() {
  useEffect(() => {
    // Reuse an existing tag if present to avoid duplicates on re-mount.
    let tag = document.querySelector('meta[name="robots"]');
    const created = !tag;
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "robots");
      document.head.appendChild(tag);
    }
    const previous = tag.getAttribute("content");
    tag.setAttribute("content", "noindex,nofollow,noarchive,nosnippet");

    return () => {
      // Restore the previous value (typically empty) so the SPA's other
      // routes stay indexable when the user navigates away.
      if (created) {
        tag.remove();
      } else if (previous != null) {
        tag.setAttribute("content", previous);
      }
    };
  }, []);
}
